<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { EventBus } from '~/code/event-bus';
import { BellRingingIcon } from 'vue-tabler-icons';

const newEvents = ref(false);

const toggleDrawer = () => {
    newEvents.value = false;
    EventBus.emit('toggleNotificationsDrawer');
};

const toastHandler = () => {
    newEvents.value = true;
};

onMounted(() => {
    EventBus.on('toast', toastHandler);
});

onUnmounted(() => {
    EventBus.off('toast', toastHandler);
});
</script>

<template>
  <v-btn icon variant="text" @click="toggleDrawer" class="custom-hover-primary ml-0 ml-md-5 text-muted">
    <v-badge v-if="newEvents" dot color="primary" offset-x="-5" offset-y="-3">
      <BellRingingIcon stroke-width="1.5" size="22" />
    </v-badge>
    <BellRingingIcon v-else stroke-width="1.5" size="22" />
  </v-btn>
</template>